import React from "react";

const CircularProgress: React.FC<{ className?: string }> = (props) => <div className={`loader ${props.className}`}>
    <img src="/assets/images/loader.svg" alt="loader" />
</div>;
export default CircularProgress;
